import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import '../../styles/ti-site.css';
import { V5ActionBar, V5Footer, V5Nav } from './V5Chrome';
import { ensureFonts } from '../../pages/tripink/shell';

/* The v5 prototype pages (home, artist pages, artist interview) bring their own neon nav + footer.
   Every other route (shop, product, cart, book now, release form, blog, videos, portfolio, artists, 404)
   is wrapped in the same v5 nav + footer + phone action bar, rebuilt in React (components/layout/V5Chrome.tsx). */
const isV5Route = (pathname: string) => pathname === '/' || pathname.startsWith('/artist/') || pathname === '/artist-interview';
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    ensureFonts();
  }, []);
  useEffect(() => {
    if (hash) {
      const t = window.setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView(), 80);
      return () => window.clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  const toaster = <Toaster theme="dark" position="bottom-right" toastOptions={{
    style: {
      borderRadius: 14,
      background: '#111015',
      border: '1px solid #2a2630',
      color: '#ece8ee'
    }
  }} data-id="element-145" data-mp="3i9jyab2lqek2" />;
  if (isV5Route(pathname)) {
    return <>
        <Outlet data-id="element-146" data-mp="38d8i39zw54kc" />
        {toaster}
      </>;
  }
  return <div className="tis" data-id="element-147" data-mp="9u0bnuwfrudz">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[80] focus:bg-white focus:px-4 focus:py-2 focus:text-ink" data-id="element-148" data-mp="9t8o97czt2ys">
        Skip to content
      </a>
      <V5Nav data-id="element-149" data-mp="3w0gl1l9uk1j7" />
      <main id="main" data-id="element-150" data-mp="3vzx6mejenv9x">
        <Outlet data-id="element-151" data-mp="3w3kwn3pn5zjw" />
      </main>
      <V5Footer data-id="element-152" data-mp="3r2wyly2zwig6" />
      <V5ActionBar data-id="element-153" data-mp="3r36svxv2pbro" />
      {toaster}
    </div>;
}